<template>
  <div class="order plaingGoldDeatails">
    <div class="box">
      <div>
        <div @mouseenter="stopImglunbo" @mouseleave="mouseLeave">
          <magnifier
            :imgurl="imgurl"
            :isPresell="DataList.isPresell"
          ></magnifier>
        </div>
        <div class="imgbox-list">
          <div
            v-for="(item, idx) in DataList.imgPathList"
            :key="idx"
            class="imgbox"
            :class="{
              active: idx === index,
            }"
            @click="changeImg(idx)"
          >
            <img :src="item" alt />
          </div>
        </div>
      </div>
      <div class="content-box">
        <div class="introduction">
          <div class="productNameClass">
            {{ DataList.productName }}
          </div>
          <div>
            <div
              v-if="!isColleFlag"
              @click="colleBtn('收藏')"
              class="introduction cursor"
            >
              <svg-icon
                style="width: 20px; height: 20px;"
                iconClass="collection_default"
                className="collection_default"
              ></svg-icon
              >收藏商品
            </div>
            <div
              v-if="isColleFlag"
              @click="colleBtn('取消')"
              class="introduction  cursor"
            >
              <svg-icon
                style="width: 20px; height: 20px;"
                iconClass="collection_selected"
                className="collection_default"
              ></svg-icon
              >已收藏
            </div>
          </div>
        </div>
        <CopyStyleNumber
          :styleNumber="DataList.styleNumber"
          :isPresell="DataList.isPresell"
        ></CopyStyleNumber>
        <div class="box_goumai">
          <div
            v-if="
              DataList.productRemark === '本地生活' ||
                DataList.productRemark === '精品严选' ||
                DataList.productRemark === '潮流爆款' ||
                DataList.productRemark === '景翠直播'
            "
          >
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                height: 40px;
                background: #ec9368;
                color: #fff;
                font-size: 16px;
                margin-bottom: 16px"
            >
              {{
                ['潮流爆款'].includes(DataList.productRemark) ? '现货' : '预定'
              }}
            </div>

            <Custom
              @selectionCustom="selectionCustom"
              ref="custom"
              :leastQuantity="DataList.leastQuantity"
              :DataList="DataList"
              :packageList="packageList"
            />
          </div>
        </div>

        <div class="addClass" v-if="comOrganization.status === 'O'">
          <div>
            (已<span>{{
              ['潮流爆款'].includes(DataList.productRemark) ? '选现货' : '预定'
            }}</span
            ><span class="addCartNumber"> {{ numberTotal.customNumber }} </span
            >件)
          </div>

          <div class="onebottom">
            <el-button @click="pushshopping">加入购物车</el-button>
          </div>
        </div>
        <div
          v-else-if="comOrganization.status === 'S'"
          style="width: 100%; line-height: 36px; text-align: right; color: red"
        >
          该网点已停运，无法加入购物车
        </div>
        <div
          v-else-if="comOrganization.status === 'F'"
          style="width: 100%; line-height: 36px; text-align: right; color: red"
        >
          该网点已冻结，无法加入购物车
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Magnifier from '../module/magnifier.vue'
import $ from 'jquery'
import { debounce } from '@/utils/index'
import Custom from './components/Custom.vue'
import CopyStyleNumber from '../../components/CopyStyleNumber.vue'
import { modifyCartPublic } from '@/api/cartApi'
import { getProductDetail, addCollection, getPackage } from '@/api/detailsApi'
import ls from '@/utils/localStorage'

export default {
  components: {
    Magnifier,
    Custom,
    CopyStyleNumber,
  },
  data() {
    return {
      productRemark: '',
      DataList: {
        category: undefined,
        productName: undefined,
        styleNumber: this.$route.query.styleNumber,
        isCouples: undefined,
        type: undefined,
        imgPathList: [],
        isLike: undefined,
        leastQuantity: undefined,
        eosGeneraName: undefined,
        productRemark: undefined,
      },

      imgurl: '',
      index: 0, //开始轮播的值
      timer: null, //停止轮播的值
      size: 0, //图片的张数
      picHeight: 0, //图片的高度
      numberTotal: {
        customNumber: 0, //单款已选现货件数
      },
      isColleFlag: false,
      packageList: [],
      comOrganization: ls.get('comOrganization'),
    }
  },
  mounted() {
    // 获取商品详情
    this.handlePackage()
    this.getProductDetail()
  },
  methods: {
    handlePackage() {
      if (this.$route.query.styleNumber === 'HHZ13003') {
        getPackage({ styleNumber: this.$route.query.styleNumber }).then(
          (res) => {
            this.packageList = res.data || []
          }
        )
      }
    },

    //选中预订
    selectionCustom(value) {
      this.numberTotal.customNumber = value
    },

    // 点击收藏
    colleBtn(text) {
      let obj = {
        id: this.$route.query.id,
        isLike: text === '收藏' ? 1 : 0,
      }
      addCollection(obj).then((res) => {
        text === '收藏' ? (this.isColleFlag = true) : (this.isColleFlag = false)
        this.$message({
          message: res.data,
          type: 'success',
          duration: 1500,
        })
      })
    },
    // 加入购物车
    pushshopping: debounce(
      function() {
        if (this.numberTotal.customNumber === 0) {
          this.$message({
            message: '下单数量不能为0',
            type: 'warning',
            duration: 1000,
          })
          return
        }

        let obj = {
          productDtoList: [],
          shopType: 2,
          type: 2,
          isCouples: this.DataList.isCouples,
          exclusiveStyle: this.DataList.exclusiveStyle,
        }
        obj.productDtoList.push(this.$refs.custom.dataFrom)

        modifyCartPublic(obj, 'post').then((res) => {
          if (res.code == 0) {
            this.$confirm('添加成功', '提示', {
              confirmButtonText: '去购物车',
              cancelButtonText: '继续添加',
              type: 'success',
            })
              .then(() => {
                this.$router.push('/shoppingCart')
              })
              .catch(() => {
                this.$refs.custom.getSupplier()
              })
          }
        })
      },
      500,
      true
    ),
    mouseLeave() {
      this.autoSlide() // 图片开始再次轮播
    },
    stopImglunbo() {
      clearInterval(this.timer)
    },

    //获取商品详情
    getProductDetail() {
      getProductDetail(this.$route.query.id).then((res) => {
        this.DataList = res.data
        //isCouples 1是情侣款 2 否
        //isPresell 1是预收款 2 否
        //isLike 0是未收藏  1是已收藏
        //isLikeTwo 0是未感兴趣  1是感兴趣
        this.isColleFlag = +res.data.isLike === 1
        this.imgurl = res.data.imgPathList[0]
        this.DataList.imgPathList = res.data.imgPathList.splice(0, 3)
      })
    },
    autoSlide() {
      // 图片轮播函数
      this.timer = setInterval(() => {
        let l = this.DataList.imgPathList.length
        // debugger
        if (this.index < l) {
          $('.imgbox').removeClass('active')
          $('.imgbox')
            .eq(this.index)
            .addClass('active')
          this.imgurl = this.DataList.imgPathList[this.index]
          this.index++
        } else {
          $('.imgbox').removeClass('active')
          $('.imgbox')
            .eq(0)
            .addClass('active')
          this.imgurl = this.DataList.imgPathList[0]
          this.index = 1
        }
      }, 3000) //每隔1.5S就切换一次图片
    },
    changeImg(index) {
      $('.imgbox').removeClass('active')
      $('.imgbox')
        .eq(index)
        .addClass('active')
      this.imgurl = this.DataList.imgPathList[index]
      this.index = index
    },
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  beforeRouteLeave(to, from, next) {
    // 从列表页去到别的页面，如果不是详情页，则不缓存列表页
    if (to.name != 'home') {
      this.$route.meta.keepAlive = false
      this.$route.meta.flag = false
    } else if (to.name == 'home') {
      this.$route.meta.keepAlive = true
      this.$route.meta.flag = true
    }
    next()
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/detailsPage.scss';

.plaingGoldDeatails {
  .content-box {
    width: 590px;
  }

  .introduction {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .cursor {
    cursor: pointer;
  }

  .productNameClass {
    font-size: 24px;
    color: #ec9368;
  }
}
</style>
